<!-- 库存记录跟踪详情-->
<template>
    <el-dialog :title="msg('出入库记录')" :close-on-click-modal="false" 
        :visible.sync="visible" width="70%"
        :fullscreen="isMinScreen"
    >
        <span><h3>库存编号：{{code}}</h3></span>
        <el-row :gutter="15">
            <el-table :data="data" :height="500" style="width: 100%" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="created" :label="msg('变更时间')" min-width="150" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="type" :label="msg('类型')" min-width="100" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-tag :type="dicts.inventoryOutType.find(d => d.value === scope.row.type).type" disable-transitions>
                            {{dicts.inventoryOutType.find(d => d.value === scope.row.type).label}}</el-tag>
                    </template>
                </el-table-column>   
                <el-table-column prop="preQty" :label="msg('原数量')" min-width="80" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="qty" :label="msg('变动数量')" min-width="80" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="totalQty" :label="msg('可用数量')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="code" :label="msg('订单编号')" min-width="130" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="createrName" :label="msg('操作人')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="remark" :label="msg('备注')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <!-- <el-table-column prop="batchCode" :label="msg('退件批次')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column> -->
                <el-table-column prop="receiver" :label="msg('收件人')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="phone1" :label="msg('收件电话')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="addr" :label="msg('收货地址')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="note" :label="msg('留言')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="phone2" :label="msg('应急电话')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
            </el-table>
        </el-row>
    </el-dialog>
    </template>
    
    <script>
    export default {
        name: 'StockTrace',
        comments: {
    
        },
        mounted: function(){
    
        },
        data(){
            return{
                id: null,
                visible: false,
                data:null,
                code:null,
            }
        },
        computed: {
            isMinScreen: {  //是否小屏幕，浏览器
                get() {
                    var is = this.$store.state.isMinScreen;
                    return is;
                }
            },
        },
        methods: {
            showTracks(id,code){
                this.visible=true;
                this.id = id;
                this.data = null;
                this.code = code;
                this.$axios.post(this.$kit.api.inventory.outTraces+"?id="+id)
                    .then((result) => {
                        if(result.status){
                            this.data = result.data;
                            if(this.data){
                                this.data.forEach(e=>{
                                    let qty = e.qty;
                                    let totalQty = e.totalQty;
                                    e.preQty = totalQty - qty;
                                })
                            }
                        }else{
                            this.$message(result.msg || this.msg('获取失败'));
                        }
                    });
            }
        }
    }
    </script>
    
    <style lang="scss" scoped>
    .trace-wrap{display:flex; justify-content: space-between;}
    .trace-box{padding: 10px;}
    .detail{margin:10px;}
    .detail a{display:inline-block; margin-left: 8px;}
    </style>